export default class UrlConfig {
  constructor(host) {
    this.host = host
  }

  getBarcodeUrl() {
    let appUrl = ''
    switch (this.host) {
      case 'b2bpro.golog.my':
        appUrl = 'https://golog-b2b-backend-isfck.ondigitalocean.app/barcode/'
        break
      case 'b2bprostaging.golog.my':
        appUrl = 'https://b2b-laravel-staging-pwvly.ondigitalocean.app/barcode/'
        break
      case 'b2bprodemo2.golog.my':
        appUrl = 'https://my-app-g2quh.ondigitalocean.app/barcode/'
        break
      default:
        appUrl = 'https://b2b-laravel-staging-pwvly.ondigitalocean.app/barcode/'
        break
    }
    return appUrl
  }

  getBaseUri() {
    let baseUrl = ''
    switch (this.host) {
      case 'b2badmin.golog.my':
        baseUrl = 'https://b2badmin.golog.my/'
        break
      case 'b2badminstaging.golog.my':
        baseUrl = 'https://b2badminstaging.golog.my/'
        break
      case 'b2badmindemo2.golog.my':
        baseUrl = 'https://b2badmindemo2.golog.my/'
        break
      default:
        baseUrl = this.host
        break
    }
    return baseUrl
  }

  getApiUrl() {
    let appUrl = ''
    switch (this.host) {
      case 'b2badmin.golog.my':
        appUrl = 'https://golog-b2b-backend-isfck.ondigitalocean.app/api/'
        break
      case 'b2badminstaging.golog.my':
        appUrl = 'https://b2b-laravel-staging-pwvly.ondigitalocean.app/api/'
        break
      case 'b2badmindemo2.golog.my':
        appUrl = 'https://my-app-g2quh.ondigitalocean.app/api/'
        break
      default:
        appUrl = 'https://b2b-laravel-staging-pwvly.ondigitalocean.app/api/'
        break
    }

    return appUrl
  }
}
